import { Subject } from 'rxjs';

export class Transaction {
  public resolvableChanges = new Subject<boolean>();

  /** Blocks the queue execution when false */
  protected _resolvable = true;
  public get resolvable(): boolean {
    return this._resolvable;
  }
  public set resolvable(value: boolean) {
    this._resolvable = value;
    this.resolvableChanges.next(value);
  }

  /** Weather the transaction was executed successfully */
  protected _executed = false;
  public get executed(): boolean {
    return this._executed;
  }

  public set executed(value: boolean) {
    if (!this._executed) {
      this._executed = value;
    }
  }

  constructor(
    public readonly id: string,
    private callable: () => void | Promise<void>
  ) {}

  public async execute(): Promise<void> {
    if (this.resolvable) {
      await this.callable();
      this.executed = true;
    } else {
      throw new Error("Can't execute a unresolvable transaction");
    }
  }
}
